module.exports = __webpack_public_path__ + "54cf98f5/img/chevron-down-icon.5542f65c.svg";